/**
 * Store Locator Custom Styles
 * This script customizes the Stockist.co widget to match the brand style
 */

(function() {
  // Apply styles when DOM is loaded
  function initStockistCustomStyles() {
    applyCustomStyles();
    
    // Set up a mutation observer to watch for changes in the DOM
    const observer = new MutationObserver(function(mutations) {
      applyCustomStyles();
    });
    
    // Start observing the document with the configured parameters
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function applyCustomStyles() {
    // Find the widget container
    const widget = document.querySelector('stockist-store-locator');
    if (!widget) return;
    widget.style.overflow = 'hidden';
    // Apply custom styles to search box
    const searchBox = widget.querySelector('.stockist-search-box');
    if (searchBox) {
      searchBox.style.backgroundColor = '#9013FE';
      searchBox.style.borderRadius = '30px';
      searchBox.style.padding = '12px 20px';
      searchBox.style.border = '2px solid white';
    }

    // Style the search input
    const searchInput = widget.querySelector('.stockist-search-field input');
    if (searchInput) {
      searchInput.style.color = 'white';
      searchInput.style.fontWeight = '600';
      searchInput.style.textTransform = 'uppercase';
      searchInput.placeholder = 'SEARCH BY ZIP CODE, CITY, OR STATE';
    }

    // Style the search button
    const searchButton = widget.querySelector('.stockist-search-button');
    if (searchButton) {
      searchButton.style.backgroundColor = '#7B0CDA';
      searchButton.style.color = 'white';
      searchButton.style.borderRadius = '30px';
      searchButton.style.fontWeight = 'bold';
    }

    // Style the result list items
    const resultItems = widget.querySelectorAll('.stockist-result-list-item');
    resultItems.forEach(item => {
      item.style.borderLeft = '4px solid #9013FE';
      item.style.padding = '15px';
    });

    // Style the result names
    const resultNames = widget.querySelectorAll('.stockist-result-name');
    resultNames.forEach(name => {
      name.style.color = '#9013FE';
      name.style.fontWeight = 'bold';
      name.style.textTransform = 'uppercase';
    });

    // Style the addresses
    const addresses = widget.querySelectorAll('.stockist-result-address');
    addresses.forEach(address => {
      address.style.textTransform = 'uppercase';
      address.style.fontSize = '0.9em';
    });

    // Style the direction links
    const directionLinks = widget.querySelectorAll('.stockist-result-directions-link a');
    directionLinks.forEach(link => {
      link.style.color = '#9013FE';
      link.style.fontWeight = 'bold';
      link.textContent = 'DIRECTIONS';
    });

    // Add a custom class to the container for easier styling
    widget.closest('.stockist-container').classList.add('hurray-girl-stockist');
  }

  // Initialize the custom styles
  document.addEventListener('DOMContentLoaded', initStockistCustomStyles);
  
  // If the page is already loaded, run immediately
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initStockistCustomStyles();
  }
  
  // Also apply styles periodically to ensure they're applied
  setInterval(applyCustomStyles, 1000);
})();
